import { useState } from 'react'
import { Layout } from '../../components/front'
import { yupResolver } from '@hookform/resolvers/yup'
import * as yup from 'yup'
import { useForm } from 'react-hook-form'

import { getProductCategories, getStaticDate } from '../../lib'
import { num_a2e, num_p2e } from '../../utils'

const schema = yup.object().shape({
    first_name: yup.string().required('نام خود را وارد کنید'),
    last_name: yup.string().required('نام خانوادگی خود را وارد کنید'),
    mobile: yup
        .string()
        .transform(function (value) {
            return num_a2e(num_p2e(value))
        })
        .matches(/^09\d{9}$/, 'شماره موبایل را به فرم 09xxxxxxxxx وارد کنید')
        .required('شماره موبایل خود را وارد کنید'),
    message: yup.string().required('پیام خود را وارد کنید')
})

export async function getServerSideProps() {
    const hier = await getProductCategories()
    const data = await getStaticDate()

    return { props: { productCategories: hier, footer: data['about_footer'].content } }
}

export default function contact({ productCategories, footer }) {
    const [success, setSuccess] = useState(false)
    const { register, handleSubmit, formState: { errors } } = useForm({
        resolver: yupResolver(schema)
    })

    async function onSubmit(data) {
        try {
            const response = await fetch('/api/graphql', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    query: `
                mutation {
                    setContacts(entity: { 
                        name: "${data.first_name} ${data.last_name}", 
                        phone: "${data.mobile}", 
                        message: "${data.message}"}) {
                            code
                            success
                            message
                    }
                }`
                })
            })
            if (response.status === 200) {
                setSuccess(true)
            } else if (response.status === 400) {
                setSuccess(false)
            }
        } catch (error) {
            console.error('An unexpected error happened occurred:', error)
        }
    }

    return (
        <Layout menu={productCategories} footer={{ about: footer }}>
            <section className="bg-gray-200 py-12">
                <div className="container mx-auto">
                    <div className="flex justify-center px-6">
                        <div className="w-full xl:w-3/4 lg:w-11/12 flex">
                            <div className="w-full lg:w-7/12 bg-white p-5 rounded-lg lg:rounded-l-none">
                                {success && (
                                    <h3 className="pt-4 text-2xl text-center mb-6 text-green-400 lg:mt-52">
                                        پیام شما ارسال شد، با تشکر
                                    </h3>
                                )}
                                {!success && (
                                    <>
                                        <h3 className="pt-4 text-2xl text-center mb-6 text-purple-400">تماس با ما</h3>
                                        <div className="rounded bg-white w-full p-5 pt-3">
                                            <form
                                                onSubmit={handleSubmit(onSubmit)}
                                                className="lg:px-8 pt-6 pb-8 mb-4 bg-white rounded"
                                            >
                                                <div className="mb-4 md:flex md:justify-between">
                                                    <div className="mb-4 md:ml-2 md:mb-0 lg:w-1/2">
                                                        <label
                                                            className="block mb-2 text-sm font-bold text-gray-700"
                                                            htmlFor="name"
                                                        >
                                                            نام *
                                                        </label>
                                                        <input
                                                            className="w-full px-3 py-2 mb-3 text-sm leading-tight rounded-md border border-gray-200 shadow-sm focus:outline-none focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50"
                                                            name="first_name"
                                                            type="text"
                                                            placeholder="نام"
                                                            {...register('first_name')}
                                                        />
                                                        {errors?.first_name?.message}
                                                    </div>
                                                    <div className="mb-4 md:ml-2 md:mb-0 lg:w-1/2">
                                                        <label
                                                            className="block mb-2 text-sm font-bold text-gray-700"
                                                            htmlFor="last name"
                                                        >
                                                            نام خانوادگی *
                                                        </label>
                                                        <input
                                                            className="w-full px-3 py-2 mb-3 text-sm leading-tight rounded-md border border-gray-200 shadow-sm focus:outline-none focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50"
                                                            name="last_name"
                                                            type="text"
                                                            placeholder=" نام خانوادگی"
                                                            {...register('last_name')}
                                                        />
                                                        {errors?.last_name?.message}
                                                    </div>
                                                </div>

                                                <div className="mb-4 md:flex md:justify-between">
                                                    <div className="mb-4 md:ml-2 md:mb-0 lg:w-full">
                                                        <label
                                                            className="block mb-2 text-sm font-bold text-gray-700"
                                                            htmlFor="mobile"
                                                        >
                                                            موبایل *
                                                        </label>
                                                        <input
                                                            className="w-full px-3 py-2 mb-3 text-sm leading-tight rounded-md border border-gray-200 shadow-sm focus:outline-none focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50"
                                                            name="mobile"
                                                            type="text"
                                                            placeholder="موبایل"
                                                            {...register('mobile')}
                                                        />
                                                        {errors?.mobile?.message}
                                                    </div>
                                                </div>
                                                <div className="mb-4">
                                                    <label
                                                        className="block mb-2 text-sm font-bold text-gray-700"
                                                        htmlFor="mobile"
                                                    >
                                                        پیام *
                                                    </label>
                                                    <textarea
                                                        className="w-full px-3 py-2 mb-3 text-sm leading-tight rounded-md border border-gray-200 shadow-sm focus:outline-none focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50"
                                                        rows="5"
                                                        placeholder="متن پیام خود را بنویسید"
                                                        name="message"
                                                        {...register('message')}
                                                    ></textarea>
                                                    {errors?.message?.message}
                                                </div>
                                                <div className="mb-6 text-center">
                                                    <button
                                                        className="w-full px-4 py-2 font-bold text-white bg-purple-400 rounded-lg hover:bg-pink-400 focus:outline-none focus:shadow-outline"
                                                        type="submit"
                                                    >
                                                        ارسال
                                                    </button>
                                                </div>
                                            </form>
                                        </div>
                                    </>
                                )}
                            </div>

                            <div
                                className="w-full h-auto bg-gray-400 hidden lg:block lg:w-5/12 bg-cover rounded-l-lg py-10"
                                style={{
                                    backgroundColor: 'white'
                                }}
                            >
                                <img src="/img/contact.png" />
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </Layout>
    )
}
